import React from 'react';
import { ElementStyleScope, type ElementStyle } from './EditableElement';
import { useAppScreens } from './useAppScreens';

/** Root-level dialogs share the screen's approved element map. Named sections
 * establish their own scopes, so their existing identities remain unchanged. */
export function ScreenElementStyleScope({ slug, styles, children }: { slug: string; styles?: Record<string, ElementStyle>; children: React.ReactNode }) {
  const screen = useAppScreens().screens.find(item => item.slug === slug && item.enabled);
  const approved = screen?.data.root.props.elementStyles;
  const value = styles ?? (approved && Object.keys(approved).length ? approved : null);
  return <ElementStyleScope scope={`${slug}-screen`} value={value}>{children}</ElementStyleScope>;
}

export function withScreenElementStyles<T extends React.ComponentType<any>>(slug: string, Component: T): React.ComponentType<React.ComponentProps<T>> {
  function StyledScreen(props: React.ComponentProps<T>) {
    return <ScreenElementStyleScope slug={slug}><Component {...props} /></ScreenElementStyleScope>;
  }
  StyledScreen.displayName = `ScreenElementStyles(${slug})`;
  return StyledScreen;
}

export function screenElementModule<T extends React.ComponentType<any>>(slug: string, module: { default: T }) {
  return { ...module, default: withScreenElementStyles(slug, module.default) };
}
